export default "__VITE_ASSET__d68dbfe4__"